import React, { Fragment, useRef, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Transition } from '@headlessui/react'
import Spinner from '../Spinner';
import { addNPSResponse } from '../../redux/actions/profileDetails';

const NPSPopup = ({ openNPSPopup, setOpenNPSPopup }) => {
    const dispatch = useDispatch()
    const user_id = useSelector(store => store?.profileDetails?.id)
    const NPSResponse = useSelector(store => store?.profileDetails?.NPSResponse)
    const [selectedOption, setSelectedOption] = useState(10)
    const [isLoading, setIsLoading] = useState(false)
    const [isResponse, setIsResponse] = useState(false)
    const cancelButtonRefNPS = useRef(null)
    const options = ['#ED343A','#F74545','#FF653F','#F98642','#FFA42A','#FBC002','#E0C600','#C5C804','#9DCA00','#77CB02','#34AC0B']

    const callback = () => {
        setIsLoading(false)
        setIsResponse(true)
    }

    const submitHandler = () => {
        setIsLoading(true)
        dispatch(addNPSResponse(selectedOption, user_id, callback))
    }

    return (
      <Transition.Root show={openNPSPopup} as={Fragment}>
            <Dialog
                as="div"
                className="fixed z-10 inset-0 overflow-y-auto"
                initialFocus={cancelButtonRefNPS}
                onClose={setOpenNPSPopup}
            >
                <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                        &#8203;
                    </span>
                    <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div
                            className="relative inline-block align-middle bg-white rounded-md text-left overflow-hidden shadow-xl transform transition-all"
                        >
                            <div className="bg-white px-4 pt-5 pb-4 sm:pt-12 sm:px-16 sm:pb-4">
                                <div className="sm:flex sm:items-start">
                                    <div className="mt-3 text-center sm:mt-0 sm:text-left">
                                    {isResponse ? (
                                        <>
                                            <Dialog.Title
                                                as="h3"
                                                className="text-lg lg:text-4xl leading-6 font-medium text-gray-900 bold"
                                            >
                                                Thanks for sharing your feedback
                                            </Dialog.Title>
                                            <p className="text-slate-500 text-center mt-6">
                                                {selectedOption > 7 ? "It seems you Extremly like the Learn Tube app" : "It seems you didn't like the Learn Tube app"}
                                            </p>
                                            <div className='flex justify-center'>
                                                <div
                                                    className='mt-10 mb-6 rounded-full cursor-pointer font-semibold text-white  text-xs sm:text-lg relative ring-4 ring-offset-2 ring-teal-500'
                                                    style={{ width: '100%', maxWidth: '80px', aspectRatio: '1', backgroundColor: options[NPSResponse?.nps_score]}}
                                                >
                                                    <div className="absolute top-1/2 left-1/2" style={{ transform: 'translate(-50%,-50%)' }}>{NPSResponse?.nps_score}</div>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <Dialog.Title
                                                as="h3"
                                                className="text-lg lg:text-2xl leading-6 font-medium text-gray-900 bold"
                                            >
                                                How likely are you to recommend LearnTube App to a friend or collegue?
                                            </Dialog.Title>
                                            <div className="mt-8 sm:ml-4 flex justify-between text-xs font-semibold">
                                                <p className="text-slate-500">0(Not likely at all)</p>
                                                <p className="text-slate-500">10(Extremly likely)</p>
                                            </div>
                                            <ul className="flex justify-between gap-1 sm:gap-2">
                                                {options.map((option, i) =>
                                                    <li
                                                        key={option}
                                                        className={`my-4 rounded-full cursor-pointer font-semibold text-white  text-xs sm:text-lg relative hover:scale-95 ${selectedOption === i && 'cursor-pointer ring-2 sm:ring-4 ring-offset-1 sm:ring-offset-2 ring-teal-500'}`}
                                                        style={{ width: '100%', maxWidth: '80px', aspectRatio: '1', backgroundColor: option}}
                                                        onClick={() => setSelectedOption(i)}
                                                    >
                                                        <div className="absolute top-1/2 left-1/2" style={{ transform: 'translate(-50%,-50%)' }}>{i}</div>
                                                    </li>
                                                )}
                                            </ul>
                                        </>
                                    )}
                                    </div>
                                </div>
                            </div>
                            <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse mb-2">
                                <button
                                    type="button"
                                    className={`w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2  text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2  sm:ml-3 sm:w-auto sm:text-sm ${!isResponse ? 'bg-teal-600 hover:bg-teal-700 focus:ring-teal-500' : 'bg-gray-600'}`}
                                    style={{minWidth: '100px'}}
                                    onClick={submitHandler}
                                    disabled={isResponse}
                                >
                                    {!isResponse ? !isLoading ? 'Submit Response' : <Spinner className={"w-4 h-4 flex justify-evenly items-center scale-125"}></Spinner> : 'Response Submitted'}
                                </button>
                                <button
                                    type="button"
                                    className="mt-2 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-10 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-500 hover:text-white focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                    onClick={() => setOpenNPSPopup(false)}
                                    ref={cancelButtonRefNPS}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
      </Transition.Root>
    )
}

export default NPSPopup
